<script setup lang="ts">
import type { NavigationLinkFragment, NavigationTreeFragment } from '#graphql-operations'
import { useChangeCase } from '@vueuse/integrations/useChangeCase.js'

interface SubmenuColumnsProps {
  submenu: NavigationTreeFragment
}

const props = defineProps<SubmenuColumnsProps>()

const submenuColumns = computed(() => props.submenu.children?.length || 0)

function changeCase(input?: string) {
  if (!input) {
    return ''
  }

  const output = useChangeCase(input, 'kebabCase')
  return output.value
}
</script>

<template>
  <li class="submenuColumns col-span-9">
    <div class="mb-10 space-y-1.5">
      <p class="typo-serif-2">
        {{ submenu.title }}
      </p>
      <ButtonLink :title="submenu.badge" :to="submenu.url">
        <template #icon>
          <i class="i-icon-arrow-right flex-none size-7.5 icon" />
        </template>
      </ButtonLink>
    </div>
    <ul v-if="submenuColumns > 0" class="columns typo-sans-1 space-y-10">
      <li v-for="link in (submenu.children as NavigationTreeFragment[])" :key="link.id" class="flex flex-col">
        <p class="typo-sans-1 mb-1em uppercase">
          {{ link.title }}
          <!-- <template v-if="link.children && link.children.length > 3">
            ({{ link.children?.length }})
          </template> -->
        </p>
        <ul v-if="(link.children?.length || 0) > 0" class="space-y-1.5">
          <li v-for="subLink in (link.children?.slice(0, Math.min((link.children?.length || 0), 3)) as NavigationLinkFragment[])" :key="subLink.id" class="flex">
            <ButtonNavSubmenu :link="subLink" />
          </li>
          <li v-if="(link.children?.length || 0) > 3">
            <ButtonLink :title="$t('view_all')" :to="`${submenu.url}#${changeCase(link.title)}`">
              <!-- <template #icon>
                <i class="i-icon-arrow-right flex-none size-7.5 icon" />
              </template> -->
            </ButtonLink>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</template>

<style scoped>
.submenuColumns > ul {
  display: grid;
  column-gap: calc(var(--spacing) * 4.5);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
</style>
